import { render } from "./RequiredSetting.vue?vue&type=template&id=606094ae"
import script from "./RequiredSetting.vue?vue&type=script&lang=js"
export * from "./RequiredSetting.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.15.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__